import React from "react";
import {WithDistance} from "@components/Booking/LocationSelection/useWithDistanceFromUser";
import {WithNextSlot} from "@components/Booking/useNextAvailable";
import {Location} from "@components/Booking/LocationSelection/types";
import NextSlotTime from "./NextSlotTime";
import NoSlots from "./NoSlots";

const TimeInfo = ({
  location,
  nextSlotTime,
}: {
  location: WithDistance<WithNextSlot<Location>>;
  nextSlotTime?: number;
}) => {
  return nextSlotTime ? (
    <NextSlotTime time={nextSlotTime} location={location} />
  ) : (
    <NoSlots location={location} />
  );
};

export default React.memo(TimeInfo);
